import * as React from 'react';
import './PVATabs.css';


export class PVATabTitle extends React.Component {
    render() {
        return <>{this.props.children}</>;
    }
}

export class PVATabContent extends React.Component {
    render() {
        return <>{this.props.children}</>;
    }
}

export class PVATab extends React.Component {
    public static Title = PVATabTitle;
    public static Content = PVATabContent;

    render() {
        return <>{this.props.children}</>;
    }
}

interface PVATabsProps {
    defaultActiveTabIndex?: number;
    onTabChange?: (index: number) => void;
    activeColor?: string;
}

interface PVATabsState {
    activeTabIndex: number;
}

export class PVATabs extends React.Component<PVATabsProps, PVATabsState> {
    public static Tab = PVATab;

    constructor(props: PVATabsProps) {
        super(props);
        this.state = {
            activeTabIndex: props.defaultActiveTabIndex || 0
        };
    }

    handleTabClick = (index: number) => {
        this.setState({ activeTabIndex: index });
        if (this.props.onTabChange) {
            this.props.onTabChange(index);
        }
    };

    render() {
        const { children, activeColor } = this.props;
        const { activeTabIndex } = this.state;

        const tabs = React.Children.toArray(children).filter(
            (child: any) => child && child.type === PVATab
        );

        if (tabs.length === 0) {
            return null;
        }

        const tabHeaders = tabs.map((tab: any, index: number) => {
            const titleChild = React.Children.toArray(tab.props.children).find(
                (child: any) => child && child.type === PVATabTitle
            );
            return (
                <div
                    key={index}
                    className={`pva-tab-item font-heading ${activeTabIndex === index ? 'active' : ''}`}
                    onClick={() => this.handleTabClick(index)}
                >
                    {titleChild || `Tab ${index + 1}`}
                </div>
            );
        });

        const activeTab: any = tabs[activeTabIndex] || tabs[0];
        const activeContent = React.Children.toArray(activeTab.props.children).find(
            (child: any) => child && child.type === PVATabContent
        );

        return (
            <div className="pva-tabs-container" style={{ '--active-tab-color': activeColor } as any}>
                <div className="pva-tabs-header">
                    {tabHeaders}
                </div>
                <div className="pva-tabs-content">
                    {activeContent}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/PVATabs.tsx